import {
    Component,
    HostListener,
    Input,
    OnInit,
    ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import panzoom from "panzoom";
import {
    CommentService,
    getMetaForImage,
    wait,
} from "@smarterplan/ngx-smarterplan-core";
import { MuseumFeatureService } from "src/app/museum/museum-feature.service";

@Component({
    selector: "app-carousel-fullscreen",
    templateUrl: "./carousel-fullscreen.component.html",
    styleUrls: ["./carousel-fullscreen.component.scss"],
})
export class CarouselFullscreenComponent implements OnInit {
    imagesLoaded: any[] = [];

    @Input() featureID: string;

    @Input() images: any[];

    @ViewChild("carousel") carousel: any;

    @Input() fromTag = true;

    @Input() selectedImageIndex: string;

    @Input() commentID: string;

    slideChanged = new Subject<any>();

    @HostListener("contextmenu", ["$event"])
    onRightClick(event) {
        event.preventDefault();
    }

    constructor(
        private route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private featureService: MuseumFeatureService,
        private commentService: CommentService,
    ) { }

    async ngOnInit() {
        this.route.params.subscribe((parameters) => {
            if (parameters.id) {
                this.featureID = parameters.id;
            }
        });
        if (this.commentID) {
            const comment = await this.commentService.getComment(
                this.commentID,
            );
            const imageMeta = await getMetaForImage(comment.annexe);
            const ratio = imageMeta.height / imageMeta.width;
            this.imagesLoaded.push({
                path: comment.annexe,
                title: comment.title,
                description: comment.description,
                ratio,
            });
        }
        if (this.images) {
            for (const image of this.images) {
                if ((this.fromTag && image.showInTag) || !this.fromTag) {
                    // eslint-disable-next-line no-await-in-loop
                    const imageMeta = await getMetaForImage(image.path);
                    const ratio = imageMeta.height / imageMeta.width;
                    this.imagesLoaded.push({
                        path: image.path,
                        title: image.title,
                        description: image.description,
                        ratio,
                    });
                }
            }
        } else if (this.featureID) {
            await this.setupFeature(this.featureID);
        }
        this.show();
    }

    async setupFeature(id: string) {
        this.imagesLoaded = [];
        const feature = await this.featureService.getFeature(id);
        for (const image of feature.images) {
            if ((this.fromTag && image.showInTag) || !this.fromTag) {
                // eslint-disable-next-line no-await-in-loop
                const imageMeta = await getMetaForImage(image.path);
                const ratio = imageMeta.height / imageMeta.width;
                this.imagesLoaded.push({
                    path: image.path,
                    title: image.title,
                    description: image.description,
                    ratio,
                });
            }
        }
    }

    onClose() {
        this.activeModal.close();
    }

    addZoom(imageIndex: number) {
        setTimeout(() => {
            const imgElement = document.getElementById(
                `img-element${imageIndex}`,
            );
            if (imgElement) {
                imgElement.classList.remove("hidden");
                panzoom(imgElement, {
                    bounds: true,
                    boundsPadding: 1,
                    maxZoom: 15,
                    minZoom: 1,
                    transformOrigin: {x: 0.5, y: 0.5}
                });
            }

            const containterDiv = document.getElementById("img-container");
            if (containterDiv) {
                const rec = containterDiv.getBoundingClientRect();
                containterDiv.style.width = `${rec.height / this.imagesLoaded[imageIndex].ratio
                    }px`;
            }
        }, 50);
    }

    navigateToSlide(item) {
        this.carousel.select(item);
    }

    async show() {
        if (!this.carousel) {
            await wait(200);
        }
        this.carousel.activeId = this.selectedImageIndex;
        this.addZoom(Number(this.selectedImageIndex));
        setTimeout(() => {
            this.carousel.slide.subscribe((event) => {
                this.addZoom(event.current);
                this.slideChanged.next(event);
            });
        }, 1000);
    }
}
